// extracted by mini-css-extract-plugin
module.exports = {"collapseMobile":"MaxWidth_collapseMobile__AWPos"};